import { FieldConfig } from '../../models/form-field.model';
import { IdValueType } from 'src/app/core/helpers/indexables.helpers';

export type FormSelectOptions<T = any> = IdValueType<T, string>[]; // | ((values, value) => IdValueType<T, string>[]);

export class FormSelectField<N, T = any> extends FieldConfig<N> {

  options?: FormSelectOptions<T>;
  groups?: {
    name: string,
    options: FormSelectOptions<T>
  }[]
  containerStyles?: any;
  selectStyles?: any;
  placeholder?: string;
  multi?: boolean;

  constructor(o: FormSelectField<N>) {
    super(o);
    this.type = 'select';
    if (Object.hasntKey(o, 'multi')) {
      this.multi = false;
    }
  }


}
